import "./intro.scss";

export default function Intro() {
  return (
    <div className="intro" id="intro">
      <div className="title">
        <link
          href="https://fonts.googleapis.com/css?family=Teko:700&display=swap"
          rel="stylesheet"
        />
        <div className="title1">
          <div  class="one" >WELCOME</div>
        </div>
      </div>
    </div>
  );
}
